import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

import { distinctUntilChanged, filter, map } from 'rxjs';

import { removeHash } from '../../helpers/url.helper';
import { WindowRefService } from '../../window-ref/window-ref.service';

@Injectable({
  providedIn: 'root'
})
export class LegacyOffcanvasService {
  static readonly OFFCANVAS_CLOSE = 'offcanvas:close';

  private readonly win: Window;

  constructor(private readonly router: Router, { nativeWindow }: WindowRefService) {
    this.win = nativeWindow;
  }

  init(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationStart && !event.url.includes('dashboard')),
        map((event: NavigationStart) => removeHash(event.url)),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.win.dispatchEvent(new CustomEvent(LegacyOffcanvasService.OFFCANVAS_CLOSE));
      });
  }
}
